import { render, staticRenderFns } from "./FleetCarrier.vue?vue&type=template&id=e5992d66&"
import script from "./FleetCarrier.vue?vue&type=script&lang=js&"
export * from "./FleetCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports